module.exports = __webpack_public_path__ + "static/img/1.22fad42.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/7/1/2/zh/1.png
// module id = YiQS
// module chunks = 0